<template>
  <zj-layout-container>
    <zj-layout-header style="padding:0rem 0px 0px 0px;">
      <div class="zj-button-bar">
        <el-upload
          style="float:right;margin-left:1rem;"
          :http-request="httpRequest"
          :data="uploadData"
          list-type="picture"
          accept=".pdf, .doc, .docx, .xls, .jpg, .jpeg, .bmp, .png"
          :show-file-list="false"
          :file-list="fileList"
          :before-upload="beforeupload"
          :on-success="uploadsuccess"
          :on-progress="uploadProgress"
          :on-error="uploadError"
        >
          <el-button size="mini" style="width:8rem"  v-if="!IsEdit">上传</el-button>
        </el-upload>
      </div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" height="100%"
        v-loading="loading" :element-loading-text="loadingText">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="FileName" label="附件名称" align="center"></el-table-column>
        <el-table-column prop="FileType" label="格式" align="center"></el-table-column>
        <el-table-column prop="ReportDate" label="上传时间" :formatter="formatDate" align="center"></el-table-column>
        <el-table-column label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-link
              v-bind:href="scope.row.FileUrl+'&d=1'"
              class="el-button el-button--text el-button--small download-link"
              target="_blank"
              :underline="false"
            >下载</el-link>
            <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small" v-if="!IsEdit">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </zj-layout-main>
    <zj-layout-footer style="padding-bottom: 0rem;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
export default {
  name: "ZjAttachList",
  controller: "UI",
  action: "AttachList",
  props: {
    PlanId: String
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      uploadData: {
        module: "Emergency", //模块名
        submodule: "Paln", //子模块
        assocID: "", //业务ID
        uploader: "EmergencyPalnAttach", //上传人
        folder: "/Emergency/Paln", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0 //扩展字段 3
      },
      fileList: [],
      OrgId: "",
      IsEdit: false
    };
  },
  created: function() {
    if (this.user.Departments != null && this.user.Departments.length > 0) {
      var dept = this.user.Departments[0];
      this.OrgId = dept.OrgId;
    }
    if (this.$route.query.obj != null) {
      this.PlanId = this.$route.query.obj;
    }
    this.IsEdit = this.$route.query.type == "edit" ? false : true;
    this.search();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    }
  },
  methods: {
    beforeupload: function() {
      this.uploadData.assocID = ZJApp.ZJUtils.uuid();
      this.loading = true;
      this.loadingText = '上传中... 0%';
    },
    uploadsuccess: function(obj) {
      this.loading = false;
      this.addPlanFile(obj);
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = '上传中... ' + parseInt(e.percent) + '%';
    },
    addPlanFile(obj) {
      if (obj && obj.name && obj.data) {
        var attach = {
          OrgId: this.OrgId,
          AttachId: this.uploadData.assocID,
          PlanId: this.PlanId,
          FileName: obj.name,
          FileActName: obj.name,
          FileUrl: obj.url,
          FileType: obj.data.Extension,
          ReportDate: new Date(),
          FileId: obj.data.FileID,
          PhysicalPath: obj.data.Path
        };
        this.loading = true;
        this.loadingText = '保存中...';
        new MyApis.PlanAttachApi()
          .AddItem(attach)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "上传成功！" : "上传失败！"
            });
            this.loading = false;
            this.search();
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
        PlanId: this.PlanId
      };
      this.loading = true;
      this.loadingText = '加载中...';
      new MyApis.PlanAttachApi()
        .GetPageContentByConditions(searchInfo)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.loadingText = '删除中...';
          new MyApis.PlanAttachApi()
            .DelItem(row)
            .then(r => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
              this.loading = false;
              this.search();
            })
            .catch(e => {
              console.error(e);
              this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
              this.loading = false;
            });
        });
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    }
  }
};
</script>